import { useQueryParams } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { omitBy } from 'lodash-es';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { pushQueryParams } from 'actions/core/navigation';
import { FilterMenu } from 'features/filter_menu';
import { getAppliedFilters } from '../utils';
import { DropdownContent } from './filter_dropdown';
import { Icon } from './icon';
const containerCss = "cwn7zsl";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const filterByCss = "f51g2g7";
const FilterBy = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filterByCss, props.className)} />;
});
const numberWrapperCss = "n1ht6b1";
const NumberWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(numberWrapperCss, props.className)} />;
});
const getButtonText = appliedFilters => <FilterBy>
    <BodyText inline as="div">{I18n.t('publisher.event_types.filters.button')}</BodyText>
    {appliedFilters > 0 && <NumberWrapper>
        {appliedFilters}
      </NumberWrapper>}
  </FilterBy>;
export const PollFiltersButton = () => {
  const params = useQueryParams();
  const dispatch = useDispatch();
  const [toggleDropdown, Wrapper, isOpen] = useDropdown();
  const isPhone = useDeviceType('isPhone');
  const appliedFilters = getAppliedFilters(params.status);
  const onCancel = () => toggleDropdown();
  const onSearch = ({
    status
  }) => {
    const searchParams = omitBy({
      ...params,
      status
    }, value => value.length === 0);
    dispatch(pushQueryParams(searchParams));
    toggleDropdown();
  };
  return <Container>
      <FilterMenu buttonText={!isPhone && getButtonText(appliedFilters.length)} hasSelection={appliedFilters.length > 0} CustomIcon={Icon} isOpen={isOpen} onClick={toggleDropdown} Wrapper={Wrapper} data-calendly-label="filter-button" disableArrow={isPhone} compact>
        <DropdownContent initialStatus={appliedFilters} onSearch={onSearch} onCancel={onCancel} />
      </FilterMenu>
    </Container>;
};

require("./filter_button.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_button.js");